import { buildPath } from 'lib/helpers/routes'
import { get, del, post, put } from './requests'

const resourcePath = 'bulk_sends'

export function cancelBulkSend (id) {
  return post(`${resourcePath}/${id}/cancel`)
}

export function cancelBulkSendDocuments (id) {
  return post(`${resourcePath}/${id}/cancel_documents`)
}

// Accepted params :filename, :base64_file, document_templates_ids: []
export function createBulkSend ({ ...bulkSend }) {
  return post(`${resourcePath}`, { bulkSend })
}

export function deleteBulkSend (id) {
  return del(`${resourcePath}/${id}`)
}

export function exportBulkSendPath ({ id, exportType }) {
  return buildPath(`${resourcePath}/${id}/export`, { export_type: exportType })
}

export function listBulkSend () {
  return get(resourcePath)
}

export function remindBulkSend (id) {
  return post(`${resourcePath}/${id}/remind`)
}

export function searchBulkSends (filters) {
  return get(resourcePath, filters)
}

export function updateBulkSend ({ id, ...bulkSend }) {
  return put(`${resourcePath}/${id}`, { bulkSend })
}

export function searchBulkSendDocuments ({ id, queryParams }) {
  return get(`${resourcePath}/${id}`, queryParams)
}
